export default "/_next/static/chunks/fonts/Outfit Medium-1d6f1a86e227bec4497dad3cc909e6e7.ttf";